import apiClient from '@/axios/index'

/**
 * 获取问卷数据
 * @param {string} questionId - 问卷ID
 * @returns {Promise} API 响应
 */
export const getQuestionnaire = async (questionId) => {
  return apiClient.get(`/svip/questionnaire/${questionId}`)
}

/**
 * 提交问卷
 * @param {string} linkToken - 问卷链接token
 * @param {Array} answers - 答案数组
 * @returns {Promise} API 响应
 */
export const submitQuestionnaire = async (linkToken, answers) => {
  return apiClient.post(`/svip/questionnaire/${linkToken}/submit`, {
    answers: answers
  })
}

/**
 * 获取文件上传URL
 * @param {string} linkToken - 问卷链接token
 * @param {number} questionId - 问题ID
 * @param {string} fileName - 文件名
 * @param {string} contentType - 文件类型
 * @param {number} fileSize - 文件大小
 * @returns {Promise} API 响应
 */
export const getUploadUrl = async (linkToken, questionId, fileName, contentType, fileSize) => {
  return apiClient.post(`/svip/questionnaire/${linkToken}/upload-url`, {
    question_id: questionId,
    file_name: fileName,
    content_type: contentType,
    file_size: fileSize
  })
}

